import React, { useState, useEffect } from 'react';
import { Button, Card, CardHeader, Table, Container, Row, Col } from 'reactstrap';
import { api } from '../../../../api';
import Cookies from 'js-cookie';

const Report = () => {
  const [reportData, setReportData] = useState([]);
  const [selectedYear, setSelectedYear] = useState('');
  const [selectedMonth, setSelectedMonth] = useState('');
  const [loading, setLoading] = useState(false);

  const emp_id = Cookies.get('token');

  const handleGenerateReport = async () => {
    const company_id = Cookies.get('company_id');
    let url = `pdfgenarate.php?engineer_task_id=${emp_id}&company_id=${company_id}`;

    if (selectedYear && selectedMonth) {
      url += `&year=${selectedYear}&month=${selectedMonth}`;
    } else if (selectedYear) {
      url += `&year=${selectedYear}`;
    } else if (selectedMonth) {
      url += `&month=${selectedMonth}`;
    }

    try {
      const response = await api.get(url);
      const path = response.data.path;
      console.log('PDF path from backend:', path);

      // Updated path handling for both production and local environments
      const baseURL = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
        ? 'http://localhost:8000/'
        : 'https://aecp.aecearth.io/'; // Use your production domain

      // Remove any leading slash from path to avoid double slashes
      const fileUrl = baseURL + path.replace(/^\/+/, '');

      // Open in new tab
      window.open(fileUrl, '_blank', 'noopener,noreferrer');
    } catch (error) {
      console.error('Error fetching report:', error);
    }
  };

  const months = [
    { value: '01', label: 'January' },
    { value: '02', label: 'February' },
    { value: '03', label: 'March' },
    { value: '04', label: 'April' },
    { value: '05', label: 'May' },
    { value: '06', label: 'June' },
    { value: '07', label: 'July' },
    { value: '08', label: 'August' },
    { value: '09', label: 'September' },
    { value: '10', label: 'October' },
    { value: '11', label: 'November' },
    { value: '12', label: 'December' },
  ];

  const currentYear = new Date().getFullYear();
  const years = [];
  for (let i = currentYear - 5; i <= currentYear + 15; i++) {
    years.push(i);
  }

  const fetchData = () => {
    setLoading(true);
    const company_id = Cookies.get('company_id');
    let url = `viewtaskByID.php?id=${emp_id}&company_id=${company_id}`;
    if (selectedYear && selectedMonth) {
      url += `&year=${selectedYear}&month=${selectedMonth}`;
    } else if (selectedYear) {
      url += `&year=${selectedYear}`;
    } else if (selectedMonth) {
      url += `&month=${selectedMonth}`;
    }

    api
      .get(url)
      .then((response) => {
        // Ensure reportData is always an array
        const data = response.data;
        if (Array.isArray(data)) {
          setReportData(data);
        } else if (data && Array.isArray(data.data)) {
          setReportData(data.data);
        } else if (data && typeof data === 'object') {
          // If it's an object, try to find an array property
          const arrayKeys = Object.keys(data).filter(key => Array.isArray(data[key]));
          if (arrayKeys.length > 0) {
            setReportData(data[arrayKeys[0]]);
          } else {
            setReportData([]);
          }
        } else {
          setReportData([]);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
        setReportData([]); // Set empty array on error
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
  }, [selectedYear, selectedMonth]);

  return (
    <>
      <div className="header bg-gradient-info py-7 py-lg-8">
        <Container fluid>
          <Row className="mb-5" />
          <Row className="mt-5">
            <Col className="mb-5 mb-xl-0" xl="12">
              <Card className="" style={{boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)', backgroundColor: '#fff', borderRadius: '15px'}}>
                <CardHeader className="border-0">
                <Row>
  {/* Header row */}
  <Col xs="12">
    <h3 className="mb-2 text-center text-md-left">Task Details</h3>
  </Col>

  {/* Controls row */}
  <Col xs="12">
    <div className="d-flex flex-column flex-md-row justify-content-center justify-content-md-start align-items-center gap-2">
      <select
        className="form-control w-auto"
        value={selectedYear}
        style={{ color: 'black', border: '1px solid black' }}
        onChange={(e) => setSelectedYear(e.target.value)}
      >
        <option value="">Year</option>
        {years.map((year) => (
          <option key={year} value={year}>{year}</option>
        ))}
      </select>
      <select
        className="form-control w-auto"
        value={selectedMonth}
        style={{ color: 'black', border: '1px solid black' }}
        onChange={(e) => setSelectedMonth(e.target.value)}
      >
        <option value="">Month</option>
        {months.map((month) => (
          <option key={month.value} value={month.value}>{month.label}</option>
        ))}
      </select>
      <Button
        style={{ backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'black' }}
        className="w-auto"
        onClick={handleGenerateReport}
      >
        Generate Report
      </Button>
    </div>
  </Col>
</Row>

                </CardHeader>
                <Table id="report-table" className="align-items-center table-flush" responsive>
                  <thead className="thead-light">
                    <tr>
                      <th scope="col">SL.No</th>
                      <th scope="col">Projects</th>
                      <th scope="col">Task</th>
                      <th scope="col">Due</th>
                      <th scope="col">StartTime</th>
                      <th scope="col">Description</th>
                      <th scope="col">Hours</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <tr>
                        <td colSpan="7" style={{ textAlign: 'center' }}>
                          Loading...
                        </td>
                      </tr>
                    ) : reportData && Array.isArray(reportData) && reportData.length > 0 ? (
                      reportData.map((item, index) => (
                        <tr key={index}>
                          <th scope="row">{index + 1}</th>
                          <td>{item.p_name || 'N/A'}</td>
                          <td>{item.taskname || 'N/A'}</td>
                          <td>{item.start_date ? item.start_date.replace('T', ' / ') : 'N/A'}</td>
                          <td>{item.end_date ? item.end_date.replace('T', ' / ') : 'N/A'}</td>
                          <td>{item.t_description ? item.t_description.replace(/<[^>]*>?/gm, '') : 'N/A'}</td>
                          <td>{item.time_taken_formatted || 'N/A'}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="7" style={{ textAlign: 'center' }}>
                          No Tasks available for selected year and month.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default Report;
